import React from "react"
import { SortableTh } from "../../components/SortableColumns"
import { Link, useNavigate } from "react-router-dom"
import { DetailLink } from "../../components/Table/DetailLink"
import { GenericOverview } from "../../components/Table/GenericOverview"
import { Col, Row } from "react-bootstrap"
import { RoleProtect } from "../../components/Authorization/RoleProtect"
import { Permission } from "../../api"

export const DeviceGroupOverview = () => {
    const endpoint = "/v2/management/firmwares"
    const navigate = useNavigate()

    const jsonDataField = (setData, data) => setData(data.firmwares)

    const filter = {
        initial: [[["type", "GROUP"]]],
        onSearch: (filters, searchText) => {
            filters.push(["AND"])
            filters.push(["name", "ilike", searchText])
            filters.push(["OR"])
            filters.push(["device_type", "ilike", searchText])
            return filters
        },
    }

    const error = {
        title: "Failed to get device groups",
        body:
            "Something went wrong while getting the device groups, " +
            "see the console for more details.",
    }

    const emptyMsg = "No device groups found"

    const table = {
        header: [
            <SortableTh column="name">Name</SortableTh>,
            <SortableTh column="device_type">Device type</SortableTh>,
            <th>Version</th>,
            <th>Actions</th>,
        ],
        body: (value) => (
            <tr
                key={value.firmware_id}
                onClick={() => {
                    navigate(`/devicegroup/${value.firmware_id}`)
                }}
            >
                <td>{value.name}</td>
                <td>{value.device_type}</td>
                <td>{value.version}</td>
                <td>
                    <DetailLink to={`/devicegroup/${value.firmware_id}`} />
                </td>
            </tr>
        ),
    }

    return (
        <Row className="content-section">
            <Col>
                <h2 className="float-start">Device groups</h2>
                <RoleProtect allowedPermissions={[Permission.SetAnyResourceFirmware]}>
                    <Link className="btn btn-success float-end mb-3" to="/devicegroup/add">
                        Add device group
                    </Link>
                </RoleProtect>
                <GenericOverview
                    apiEndpoint={endpoint}
                    dataField={jsonDataField}
                    filter={filter}
                    error={error}
                    table={table}
                    emptyMsg={emptyMsg}
                    extraParam={"&include_version=true"}
                />
            </Col>
        </Row>
    )
}
